Pegasus.PaletteController = Em.ObjectController.extend({
  changePalette: function(view){
    Pegasus.stateMachine.send('changePalette', view);
  }
});
